import { LazyLoadComponent, LazyLoadImage } from 'react-lazy-load-image-component';
import { hostUrlConverter, imgUrlConverter } from '../../../../util';

export const AdsBannerCardImage = ({
    productName,
    productURL,
    productImageURL,
    desktopImageUrl,
    mobileImageUrl,
    scrollPosition
}) => {
    const desktopImageUrlFinal = imgUrlConverter(desktopImageUrl ? desktopImageUrl : productImageURL)
    const mobileImageUrlFinal = imgUrlConverter(mobileImageUrl ? mobileImageUrl : productImageURL)

    return (
        <a role="button" href={hostUrlConverter(productURL)}>
            <div className="img-wrapper">
                <LazyLoadComponent>
                    <picture>
                        <source media="(min-width: 1024px)" srcSet={desktopImageUrlFinal} />
                        <LazyLoadImage src={mobileImageUrlFinal} alt={productName} scrollPosition={scrollPosition} />
                    </picture>
                </LazyLoadComponent>
            </div>
        </a>
    )
}